import { FormattedText } from "@tm/static";
import React from "react";
import CloseIcon from "../../../../../icons/CloseIcon";
import {
  CoachMarkBubble,
  CoachMarkClose,
  CoachMarkContent,
  CoachMarkIcon,
  CoachMarkSubtitle,
  CoachMarkTitle,
  CoachMarkWrapper,
} from "./CoachMark.styles";
import { IPopOverData } from "./types";

interface CoachMarkProps extends IPopOverData {
  onDismiss?: () => void;
}

const CoachMark: React.FC<CoachMarkProps> = ({
  icon,
  title,
  subTitle,
  onDismiss,
}) => {
  if (!title && !subTitle) return null;

  return (
    <CoachMarkWrapper>
      <CoachMarkBubble>
        {icon && <CoachMarkIcon src={icon} alt="" />}
        <CoachMarkContent>
          {title && (
            <CoachMarkTitle>
              <FormattedText value={title} />
            </CoachMarkTitle>
          )}
          {subTitle && (
            <CoachMarkSubtitle>
              <FormattedText value={subTitle} />
            </CoachMarkSubtitle>
          )}
        </CoachMarkContent>
        <CoachMarkClose type="button" onClick={onDismiss} aria-label="Dismiss">
          <CloseIcon width="12" height="12" />
        </CoachMarkClose>
      </CoachMarkBubble>
    </CoachMarkWrapper>
  );
};

export default CoachMark;
